var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback } from "react";
import * as qs from "qs";
import { BodyType, DefaultRequestOptions, } from "./RequesterTypes";
import { createContainer } from "unstated-next";
import { SettingsContainer } from "@JS/nn4m-settings";
function useRequester(initialState) {
    var _this = this;
    if (initialState === void 0) { initialState = {}; }
    var getToken = initialState.getToken, updateToken = initialState.updateToken;
    var statusMessage = useCallback(function (res) {
        switch (res.status) {
            case 404:
                return "could not find";
            case 400:
                return "400: Bad Request";
            case 401:
                return "Not authorized to access this content";
            case 403:
                return "Not authorized to access this content";
            default:
                return res.status + ": " + res.statusText;
        }
    }, []);
    var getBody = useCallback(function (options) {
        if (options.body) {
            switch (options.bodyType) {
                case BodyType.JSON:
                    return JSON.stringify(options.body);
                case BodyType.FORM:
                    return qs.stringify(options.body);
                default:
                    return options.body;
            }
        }
        else {
            return undefined;
        }
    }, []);
    var getOptionsWithMissingDefaultValues = useCallback(function (options) {
        return __assign(__assign({}, DefaultRequestOptions), options);
    }, []);
    var getRequestHeaders = useCallback(function (options) {
        if (options.headers) {
            return options.headers;
        }
        var requestHeaders = new Headers();
        if (options.bodyType !== BodyType.DEFAULT) {
            requestHeaders.append("Content-Type", options.bodyType);
        }
        if (options.needsAuthorization && getToken) {
            requestHeaders.append("Authorization", "Bearer " + (getToken() || ""));
        }
        return requestHeaders;
    }, [getToken]);
    var request = useCallback(function (method, route, requestOptions) {
        var options = getOptionsWithMissingDefaultValues(requestOptions);
        var promise = new Promise(function (resolve, reject) {
            fetch(route, {
                method: method,
                body: getBody(options),
                headers: getRequestHeaders(options),
            })
                .then(function (r) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (r.status === 200) {
                        try {
                            resolve(options.resolver(r));
                        }
                        catch (e) {
                            resolve();
                        }
                    }
                    reject(statusMessage(r));
                    return [2 /*return*/];
                });
            }); })
                .catch(function (e) {
                reject(e);
            });
        });
        if (updateToken) {
            return new Promise(function (resolve) {
                updateToken(function () { return resolve(promise); });
            });
        }
        return promise;
    }, [
        getBody,
        getOptionsWithMissingDefaultValues,
        getRequestHeaders,
        statusMessage,
        updateToken,
    ]);
    var requestBlob = useCallback(function (method, route, requestOptions) {
        return request(method, route, __assign(__assign({}, requestOptions), { resolver: function (response) { return response.blob(); } }));
    }, [request]);
    var parseHeaders = useCallback(function (headers) {
        var headersObject = JSON.parse(headers);
        var result = new Headers();
        Object.keys(headersObject).forEach(function (key) {
            var value = headersObject[key];
            result.append(key, value);
        });
        return result;
    }, []);
    var settings = SettingsContainer.useContainer();
    var requestFromCollection = useCallback(function (urlSettingsKey, substitutions, requestOptions) {
        var urlCollection = settings.urlCollection(urlSettingsKey, __assign(__assign({}, substitutions), { TOKEN: getToken ? getToken() || "" : "" }));
        var method = urlCollection.method, url = urlCollection.url, payload = urlCollection.payload, headers = urlCollection.headers;
        return request(method, url, __assign(__assign({}, requestOptions), { headers: parseHeaders(headers), body: payload !== "" ? JSON.parse(payload) : undefined }));
    }, [getToken, parseHeaders, request, settings]);
    return {
        request: request,
        requestBlob: requestBlob,
        requestFromCollection: requestFromCollection,
    };
}
export var RequesterContainer = createContainer(useRequester);
